import React from "react"
import styled from "styled-components"
import { Link } from "gatsby"
import { Settings } from "../../../styles/theme"

import Cookies from "universal-cookie"

const Popup = styled.div`
  position: fixed;
  z-index: 1000;
  bottom: 0;
  width: 100%;
  background: rgba(0, 0, 0, 0.7);
  padding: 2rem 0;
  display: ${props => (props.toggle ? "block" : "none")};
  > div {
    max-width: 1040px;
    width: 80%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    div:first-of-type {
      flex: 1 1 70%;
    }
    div:last-of-type {
      flex: 1 1 20%;
      text-align: center;
      button {
        background: ${Settings.primaryColor};
        color: #fff;
        padding: 1rem 2rem;
        border: none;
        cursor: pointer;
      }
    }
  }
  p,
  a {
    color: #fff;
  }
`

export class Cookie extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      toggle: false,
    }
  }
  componentDidMount = () => {
    const cookies = new Cookies()
    if (
      cookies.get("cookieAgreement") === "false" ||
      cookies.get("cookieAgreement") === undefined
    ) {
      this.setState({ toggle: true })
    }
    console.log(cookies.get("cookieAgreement"))
  }
  agreeCookie = () => {
    const cookies = new Cookies()
    cookies.set("cookieAgreement", "true", { path: "/" })
    this.setState({
      toggle: false,
    })
  }
  render() {
    return (
      <Popup toggle={this.state.toggle}>
        <div>
          <div>
            <p>
              <b>This website uses cookies</b>
            </p>
            <p>
              We use cookies to personalise content and ads, to provide social
              media features and to analyze our traffic.
            </p>
            <p>
              We also share information about your use of our site with social
              media, advertising and analytics partners who may combine it with
              other information that you’ve provided to them or that they’ve
              collected from your use of their services consent to our cookies
              if you continue to use this website.
            </p>
          </div>
          <div>
            <button onClick={this.agreeCookie}>I ACCEPT</button>
          </div>
        </div>
      </Popup>
    )
  }
}
